var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "rotate(-180 6 6)",
    fill: "#3A97D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 9.62828L7.09058 6.31453C7.09058 6.10484 6.96937 6 6.72695 6L5.2724 6C5.02998 6 4.90877 6.10484 4.90877 6.31453L4.66634 9.62828C4.66634 9.74265 4.70674 9.82844 4.78755 9.88562C4.84816 9.96187 4.92897 10 5.02998 10L6.96937 10C7.07038 10 7.16129 9.96187 7.2421 9.88562C7.3027 9.82844 7.33301 9.74265 7.33301 9.62828Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 4.6665C5.63252 4.6665 5.32335 4.53124 5.07214 4.26071C4.80161 4.0095 4.66634 3.70032 4.66634 3.33317C4.66634 2.96602 4.80161 2.64718 5.07214 2.37665C5.32335 2.12544 5.63253 1.99984 5.99967 1.99984C6.36682 1.99984 6.68566 2.12544 6.9562 2.37665C7.2074 2.64718 7.33301 2.96602 7.33301 3.33317C7.33301 3.70032 7.2074 4.0095 6.9562 4.26071C6.68566 4.53124 6.36682 4.6665 5.99967 4.6665Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.5407e99ca434aac7fa73897267f16b74.svg";
export { ForwardRef as ReactComponent };